export class EntitlementModel {
  constructor(
    public entitlementId: string,
    public productName: string,
    public guestAgeGroup: string,
    public startDateTime: string,
    public endDateTime: string,
    public linked: boolean,
    public shared: boolean,
    public parkHopper: boolean,
    public category: { id: string, name: string, displayInMobile: boolean },
    public supplements?: any,
    public assignedGuest?: { nickname: string, firstName: string, lastName: string }
  ) {
    this.entitlementId = entitlementId;
    this.productName = productName;
    this.guestAgeGroup = guestAgeGroup;
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.linked = linked;
    this.shared = shared;
    this.parkHopper = parkHopper;
    this.category = {
      'id': category['id'],
      'name': category['name'],
      'displayInMobile': category['displayInMobile']
    };

    if (assignedGuest !== null) {
      this.assignedGuest = {
        'nickname': assignedGuest['nickname'],
        'firstName': assignedGuest['firstName'],
        'lastName': assignedGuest['lastName']
      };
    }

    if (supplements !== null) {
      this.supplements = supplements;
    }
  }
}
